import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExpectedOwnedStrategy } from 'src/app/shared/owned-strategy-card/strategy';

@Component({
  selector: 'libero-draft-accept-refuse-confirm-modal',
  templateUrl: './draft-accept-refuse-confirm-modal.component.html',
  styleUrls: ['./draft-accept-refuse-confirm-modal.component.scss'],
  standalone: false
})
export class DraftAcceptRefuseConfirmModalComponent {
  @Input() public show: boolean | null = null;
  @Input() public type: 'accept' | 'refuse' | null = null;
  @Input() public portfolio: ExpectedOwnedStrategy | null = null;
  @Output() public yesBtnClick = new EventEmitter<void>();
  @Output() public noBtnClick = new EventEmitter<void>();
  @Input() public loadingConfirm: boolean | null  = false;

  public onYesBtnClick(): void {
    if (!this.loadingConfirm) {
      this.loadingConfirm = true;
      this.yesBtnClick.emit();
    }
  }

  public onNoBtnClick(): void {
    this.noBtnClick.emit();
  }

}
